export function isCode(value) {
  let myRegularExpression = new RegExp(/var\s*.*;/g);
  if (value.match(/var|const|let|console|print|{}|div class|a href=|<div/g)) {
    return true;
  }
  return false;
}
